// Главная — «сердце компании» (решение Анны 03.11.2026). Чистая логика: приветствие, фраза-пульс,
// что горит, претензии. Данные — те же, что у «Сводки логиста» и «Претензионной работы».

export const OFFICE_TZ = 'Europe/Ulyanovsk'

export function greeting(hour) {
  if (hour >= 5 && hour < 12) return 'Доброе утро'
  if (hour >= 12 && hour < 17) return 'Добрый день'
  if (hour >= 17 && hour < 23) return 'Добрый вечер'
  return 'Доброй ночи'
}

export function officeParts(date = new Date(), tz = OFFICE_TZ) {
  const f = new Intl.DateTimeFormat('ru-RU', {
    timeZone: tz, hour: '2-digit', minute: '2-digit', weekday: 'long', day: 'numeric', month: 'long', hourCycle: 'h23',
  })
  const parts = Object.fromEntries(f.formatToParts(date).map((p) => [p.type, p.value]))
  return {
    hour: Number(parts.hour),
    time: parts.hour + ':' + parts.minute,
    date: parts.weekday + ', ' + parts.day + ' ' + parts.month,
  }
}

// Имя для приветствия: «Анна», «Иванова Анна Сергеевна» → «Анна», «Иванова Анна» → «Анна».
const SURNAME = /(ова|ева|ёва|ина|ына|ая|ов|ев|ёв|ин|ын|ский|цкий|ко|ук|юк)$/i
export function firstName(full) {
  const w = String(full || '').trim().split(/\s+/).filter(Boolean)
  if (w.length >= 3) return w[1]
  if (w.length === 2 && SURNAME.test(w[0]) && !SURNAME.test(w[1])) return w[1]
  return w[0] || ''
}

export function plural(n, one, few, many) {
  const a = Math.abs(n) % 100
  const b = a % 10
  if (b === 1 && a !== 11) return one
  if (b >= 2 && b <= 4 && (a < 12 || a > 14)) return few
  return many
}

// Одна фраза о состоянии компании — по светофору и критичным рейсам.
export function pulse(lights, totals) {
  const overall = lights?.overall
  const critical = Number(totals?.critical) || 0
  const need = Number(totals?.needs_executor) || 0
  if (!lights && !totals) return { state: 'gray', text: 'Собираем данные о рейсах…' }
  if (overall === 'red' || critical > 0) {
    const parts = []
    if (critical) parts.push(critical + ' ' + plural(critical, 'критичный рейс', 'критичных рейса', 'критичных рейсов'))
    if (need) parts.push(need + ' ' + plural(need, 'ждёт', 'ждут', 'ждут') + ' исполнителя')
    return { state: 'red', text: parts.length ? 'Нужно вмешаться: ' + parts.join(', ') + '.' : 'Нужно вмешаться: есть красные показатели.' }
  }
  if (overall === 'yellow' || need > 0) {
    return { state: 'yellow', text: need ? 'Обратите внимание: ' + need + ' ' + plural(need, 'рейс ждёт', 'рейса ждут', 'рейсов ждут') + ' исполнителя.' : 'Обратите внимание: есть жёлтые показатели.' }
  }
  if (overall === 'gray') return { state: 'gray', text: 'Часть показателей сейчас недоступна.' }
  return { state: 'green', text: 'Всё идёт по плану — можно заниматься развитием.' }
}

const LEVEL_RANK = { critical: 3, warning: 2, attention: 2, info: 1 }

// Что горит: группы «Сводки» с рейсами, сначала критичные и большие.
export function hotGroups(groups = [], limit = 4) {
  return groups
    .filter((g) => Number(g.count) > 0 && (LEVEL_RANK[g.level] || 0) >= 2)
    .sort((a, b) => (LEVEL_RANK[b.level] || 0) - (LEVEL_RANK[a.level] || 0) || b.count - a.count)
    .slice(0, limit)
    .map((g) => ({ key: g.key, title: g.title, hint: g.hint, count: g.count, level: g.level }))
}

export function claimsTop(segments = [], limit = 3) {
  return segments
    .filter((s) => Number(s.count) > 0)
    .sort((a, b) => (LEVEL_RANK[b.level] || 0) - (LEVEL_RANK[a.level] || 0) || (b.amount || 0) - (a.amount || 0) || b.count - a.count)
    .slice(0, limit)
    .map((s) => ({ key: s.key, title: s.title, count: s.count, amount: s.amount || 0, overdue: s.overdue || 0, level: s.level }))
}

export function claimsMoney(segments = []) {
  return segments.reduce((sum, s) => sum + (Number(s.amount) || 0), 0)
}

export function money(n) {
  const v = Math.round(Number(n) || 0)
  return v.toLocaleString('ru-RU').replace(/[  ]/g, ' ') + ' ₽'
}

// Плавный счёт чисел: 0 → цель за duration мс (easeOutExpo).
export function easeOut(t) {
  return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t)
}

export function boardState(lights, key) {
  const b = (lights?.boards || []).find((x) => x.key === key)
  return b ? { state: b.state, title: b.title, text: b.text } : { state: 'gray', title: '', text: 'Нет данных' }
}
